import * as React from 'react';
import * as style from './mortgage.css';
import { IAdFoxBannerContext } from '@cian/adfox';
import { IWithTrackingProps } from '../../../../hoc/withTracking';
import { trackAdFoxMortgage } from '../../../../../tracking/adFoxMortgage';
import classNames from 'classnames';

export interface IMortgageSimpleBannerOwnProps {
  context: IAdFoxBannerContext;
}

export interface IMortgageSimpleBannerStateProps extends IWithTrackingProps {
  isRedesignEnabled: boolean;
}

export type TMortgageSimpleBannerProps = IMortgageSimpleBannerStateProps & IMortgageSimpleBannerOwnProps;

export class MortgageSimpleBanner extends React.PureComponent<TMortgageSimpleBannerProps> {
  public static shownBannerIds: string[] = [];

  public componentDidMount(): void {
    this.track(true);
  }

  public render() {
    const {
      isRedesignEnabled,
      context: { reference, text },
    } = this.props;

    return (
      <div>
        {!isRedesignEnabled && <span className={style['label']}>или</span>}
        <a
          data-mark="MortgageSimpleBannerLink"
          href={reference}
          target={'_blank'}
          className={classNames(style['button'], isRedesignEnabled && style['button-new'])}
          onClick={this.onClick}
        >
          {text}
        </a>
      </div>
    );
  }

  private onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    this.track(false);
  };

  private track = (isShow: boolean) => {
    const {
      tracking: { user, page },
      context: { bannerId },
    } = this.props;

    // Костыль, на время, пока не исправится ПОЛНАЯ перерисовка всего листинга
    // при каждом чихе (даже открытии какого-то попапа в карточке). Каждый
    // раз вызывается componentDidMount, потому что по какой-то причине весь
    // листинг реинициализируется. Таким образом мы избавляемся от логической
    // ошибки, когда в реалии трекинг ссылки должен срабатывать один раз
    // при ее показе, но срабатывает КАЖДЫЙ, когда перерисовывается вся
    // страница.
    if (isShow) {
      if (MortgageSimpleBanner.shownBannerIds.includes(bannerId)) {
        return;
      }
      MortgageSimpleBanner.shownBannerIds.push(bannerId);
    }

    trackAdFoxMortgage(isShow ? 'show' : 'click', 'LinkIpoteka', bannerId, user, page);
  };
}
